import { render, staticRenderFns } from "./ColumnasTable.vue?vue&type=template&id=b5844a46&scoped=true"
import script from "./ColumnasTable.vue?vue&type=script&lang=ts"
export * from "./ColumnasTable.vue?vue&type=script&lang=ts"
import style0 from "./ColumnasTable.vue?vue&type=style&index=0&id=b5844a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5844a46",
  null
  
)

export default component.exports